import { UIHeading3, UIText3 } from '@cian/ui-kit';

import { type PropsWithChildren, type ReactNode, useMemo } from 'react';

import styles from './HighwaysModalContent.css';

export function HighwaysModalContent({ children }: PropsWithChildren): ReactNode {
  return <div className={styles['container']}>{children}</div>;
}

HighwaysModalContent.Column = function Column({ children }: PropsWithChildren): ReactNode {
  return <div className={styles['column']}>{children}</div>;
};

HighwaysModalContent.Centered = function Centered({ children }: PropsWithChildren): ReactNode {
  return <div className={styles['centered']}>{children}</div>;
};

HighwaysModalContent.Group = function Group({ children }: PropsWithChildren): ReactNode {
  return <div className={styles['group']}>{children}</div>;
};

const HIGHWAY_GROUP_DIRECTIONS_MAP: {
  [name: string]: string;
} = {
  Белорусское: 'запад',
  Курское: 'юг',
  Савеловское: 'север',
  Рижское: 'северо-запад',
  Ярославское: 'северо-восток',
  Горьковское: 'восток',
  Ленинградское: 'северо-запад',
  Казанское: 'юго-восток',
  Павелецкое: 'юго-восток',
  Киевское: 'юго-запад',
};

HighwaysModalContent.Header = function Header({ title, onClick }: { title: string; onClick: () => void }): ReactNode {
  const subtitle = useMemo(() => {
    return HIGHWAY_GROUP_DIRECTIONS_MAP[title];
  }, [title]);

  return (
    <div className={styles['header']}>
      <div className={styles['header-inner']} role="button" onClick={onClick}>
        <UIHeading3 color="current_color">{title}</UIHeading3>
        {subtitle && <UIText3 color="gray60_100">{subtitle}</UIText3>}
      </div>
    </div>
  );
};

HighwaysModalContent.List = function List({ children }: PropsWithChildren): ReactNode {
  return <ul className={styles['list']}>{children}</ul>;
};

HighwaysModalContent.ListItem = function ListItem({ children }: PropsWithChildren): ReactNode {
  return <li className={styles['list-item']}>{children}</li>;
};
